module.exports = __webpack_public_path__ + "static/media/23-7.4aa2e274.mp3";